import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-user',
  standalone: true,
  templateUrl: '../../assets/user.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamUserIcon {}
